import { render, staticRenderFns } from "./SignOffEdit.vue?vue&type=template&id=5dfab9cd&scoped=true"
import script from "./SignOffEdit.vue?vue&type=script&lang=js"
export * from "./SignOffEdit.vue?vue&type=script&lang=js"
import style0 from "./SignOffEdit.vue?vue&type=style&index=0&id=5dfab9cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfab9cd",
  null
  
)

export default component.exports